import { useHeaderActions } from "../../hooks/useHeaderActions";
import { HeaderTab } from "../explore/HeaderTab";

export type ProfileTab = "read" | "following" | "settings";

/** Puts History, Following and Settings into the mobile header while a profile page is open (renders nothing itself). */
export const ProfileTabs = ({ active }: { active: ProfileTab }) => {
  useHeaderActions(
    () => (
      <div class="flex items-end h-full">
        <HeaderTab href="/profile" class="hidden-anonymous" isActive={active === "read"}>
          History
        </HeaderTab>
        <HeaderTab href="/profile/following" class="hidden-anonymous" isActive={active === "following"}>
          Following
        </HeaderTab>
        <HeaderTab href="/profile/settings" isActive={active === "settings"}>
          Settings
        </HeaderTab>
      </div>
    ),
    [active],
  );
  return null;
};
